export const MAX_SCREEN_BODY_WIDTH = '100%';
export const LEFT_NAV_WIDTH = 88;
export const HEADER_HEIGHT = 72;
